/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/*
 * The file is automatically generated by Serenity UI.
 *
 * ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
 *
 * Found an issue? Submit a task to the ClickUp board:
 * https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
 */
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const HamburgerMenuStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M0.700012 6C0.700012 5.72386 0.92387 5.5 1.20001 5.5H22.8C23.0762 5.5 23.3 5.72386 23.3 6C23.3 6.27614 23.0762 6.5 22.8 6.5H1.20001C0.92387 6.5 0.700012 6.27614 0.700012 6ZM0.700012 12C0.700012 11.7239 0.92387 11.5 1.20001 11.5H22.8C23.0762 11.5 23.3 11.7239 23.3 12C23.3 12.2761 23.0762 12.5 22.8 12.5H1.20001C0.92387 12.5 0.700012 12.2761 0.700012 12ZM1.20001 17.5C0.92387 17.5 0.700012 17.7239 0.700012 18C0.700012 18.2761 0.92387 18.5 1.20001 18.5H22.8C23.0762 18.5 23.3 18.2761 23.3 18C23.3 17.7239 23.0762 17.5 22.8 17.5H1.20001Z"
          fill="#0A0A0A"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </svg>
    </Icon>
  );
});

export { HamburgerMenuStrokeIcon };
